import { createSelector } from '@reduxjs/toolkit';
import { FEATURE_SELECTION_MODES } from '@carto/react-core';
import { SpatialFilter } from '@carto/react-ui';
import { CartoState, ClusterSelection, LineSelection, SelectedLasso } from './reducer';
import { RootState } from '../index';

type Selector<T> = (state: RootState) => T;

const defaultLineSelection = {
  spatialFilters: [],
  featureSelectionMode: FEATURE_SELECTION_MODES.POLYGON,
  featureSelectionEnabled: false,
};

export const getCarto = (state: RootState): CartoState => state.carto;

export const getCartoLineSelections = createSelector([getCarto], (carto: CartoState) => carto.lineSelections);

export const getSelectedCluster = createSelector([getCarto], (carto: CartoState) => carto.selectedCluster);

export const getSelectedLasso = createSelector([getCarto], (carto: CartoState) => carto.selectedLasso);

export const getCartoSelectionForLineId = (lineId: string): Selector<LineSelection> =>
  createSelector([getCartoLineSelections], (lineSelections): LineSelection => {
    return lineSelections[lineId] ?? defaultLineSelection;
  });

export const getCartoSpatialFilterForLineId = (lineId: string): Selector<SpatialFilter[]> =>
  createSelector([getCartoSelectionForLineId(lineId)], (lineSelection): SpatialFilter[] => {
    return lineSelection?.spatialFilters;
  });

export const getIsFurnitureCardSelection = createSelector(
  [getSelectedCluster, getSelectedLasso],
  (selectedCluster: ClusterSelection, selectedLasso: SelectedLasso) => {
    return Boolean(selectedCluster?.furnitureCode || selectedLasso?.polygonId);
  },
);
